import { Axiom } from '@axiomhq/js'

// Shared Axiom client (ingest token). Used by both the server and client loggers.
// The token is intentionally NEXT_PUBLIC_ because the client logger ingests directly
// from the browser (an ingest-only token, same exposure as the old Vercel endpoint).
const axiomClient = new Axiom({
  token: process.env.NEXT_PUBLIC_AXIOM_TOKEN ?? '',
})

export default axiomClient
